import React, { useCallback, useMemo } from 'react';
import { FormGroup, Label } from 'reactstrap';
import AdminShapePreview from 'Component/Learning/BankQuestion/AdminShapePreview';

/**
 * ClickablePresetEditor
 * - Admin menentukan nilai clickable (0/1/2) langsung dari klik di Konva
 * - Output: `number[]` sesuai mapping shape:
 *   - box: [O_TL,O_TR,O_BL,O_BR, I_TL,I_TR,I_BL,I_BR]
 *   - triangle: [TOP, LEFT, RIGHT, CENTER]
 *   - boxhard: [0-7 outer triangles, 8-15 inner triangles]
 */
export default function ClickablePresetEditor(props) {
  const {
    variant,
    preset,
    isDisabled,
    onChangePreset,
    height = 360,
  } = props;

  const legend = useMemo(() => (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
      {/* Legend ini bantu admin ngerti arti angka saat klik */}
      <small><strong>0</strong> = putih</small>
      <small><strong>1</strong> = orange</small>
      <small><strong>2</strong> = pattern</small>
      <small style={{ opacity: 0.8 }}>(klik untuk cycle 0→1→2)</small>
    </div>
  ), []);

  const handleChangeValues = useCallback((nextValues) => {
    // `AdminShapePreview` akan memanggil callback ini saat cell/triangle diklik
    if (!Array.isArray(nextValues)) return;
    onChangePreset?.(nextValues);
  }, [onChangePreset]);

  if (!variant) return null;

  return (
    <FormGroup className="mb-3">
      <Label style={{ fontWeight: 'bold' }}>{'Nilai (klik pada bentuk)'}:</Label>
      {legend}

      <div style={{ marginTop: 10 }}>
        <AdminShapePreview
          variant={variant}
          preset={preset}
          readOnly={Boolean(isDisabled)}
          height={height}
          onChangeValues={handleChangeValues}
        />
      </div>
    </FormGroup>
  );
}
